/*eslint new-cap:0 */
import ko from 'knockout';
import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';
import { mediumEnum } from '@bingads-webui-campaign-react/constants';

const s$AdGroup = window.globalLegacySchema.get('AdGroup');
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const CoOpCampaignSubType = 10;
const SponsoredCampaignSubType = 11;
const BidValueAdGroupType = 0;
const permissions = config.get('Permissions') || {};
const isSponsoredPilotEnabled = Boolean(_.result(permissions, 'IsSPAv2Enabled', false));
const isWindowsStoreAdsManualCPAEnabled = Boolean(_.result(permissions.dynamic, 'WindowsStoreAdsManualCPA', false));

export default class ViewModel {
  constructor({
    AdDistribution = 'BingYahooAndSearchPartners',
    Medium = '',
    campaignSubType = null,
    showSynd = true,
    isSPBCampaign = false,
    isMSStoreAdsGAWorkflow,
  } = {}) {
    const subTypeFromCampaign = _.result(config.get('CurrentCampaign'), 'CampaignSubType');

    this.isMicrosoftStoreAd = isMSStoreAdsGAWorkflow;

    koSchema.properties(this, s$AdGroup, ['AdDistribution', 'Medium'], {
      AdDistribution: this.isMicrosoftStoreAd && !isMSStoreAdsGAWorkflow ? 'InHousePromotion' : AdDistribution,
      Medium: Medium || mediumEnum.Search,
    });

    // control enable or disable synd options, depending on language and selected location targetings
    this.syndAllowed = ko.observable(true);

    //control show or hidden synd options, only depending on selected adgroup language
    this.showSynd = ko.observable(showSynd);

    this.isSPBCampaign = ko.observable(isSPBCampaign);

    this.Medium.searchSelected = ko.computed({
      read() {
        return _.contains([mediumEnum.Mixed, mediumEnum.Search], this.Medium());
      },
      write(selected) {
        if (selected) {
          this.Medium(mediumEnum.Search);
        } else {
          this.Medium('');
        }
      },
    }, this);

    const enumValidator = _.result(this.Medium.validators, 'enum');

    if (enumValidator) {
      enumValidator.message = i18n.get('Validation_AdDistribution_NetworkRequired');
    }

    this.enableSynd = ko.computed(() => {
      // only enable synd when search network is selected and language/location targetings support
      return this.Medium.searchSelected() && this.syndAllowed() && !(this.isMicrosoftStoreAd && !isWindowsStoreAdsManualCPAEnabled);
    });

    /** When to show in-house option:
      In settings page, show InHouse option when it's co-op adgroup with bid value option
      In creation page, if AdDistribution is undefined, will by default hide in-house option
    */
    this.showInHouse = ko.observable((() => {
      if (this.isMicrosoftStoreAd) {
        return true;
      }

      if (!isSponsoredPilotEnabled || !AdDistribution) {
        return false;
      }

      if (campaignSubType === 'ShoppingSponsoredProductAd' || subTypeFromCampaign === SponsoredCampaignSubType) {
        return !this.isSPBCampaign();
      }

      if (subTypeFromCampaign !== CoOpCampaignSubType) {
        return false;
      }

      const settings = _.result(config.get('CurrentAdGroup'), 'Settings');
      const bidOption = _.result(_.first(settings), 'BidOption');

      return bidOption === BidValueAdGroupType;
    })());
  }
}

